const getClosestFreeIndex = (usedIndexes, preferredIndex) => {
  if (!usedIndexes[preferredIndex]) {
    return preferredIndex;
  }

  return getClosestFreeIndex(usedIndexes, preferredIndex + 1);
};

export default getClosestFreeIndex;
